import { render, staticRenderFns } from "./ShareMenu.vue?vue&type=template&id=5320fccc&"
import script from "./ShareMenu.vue?vue&type=script&lang=js&"
export * from "./ShareMenu.vue?vue&type=script&lang=js&"
import style0 from "./ShareMenu.vue?vue&type=style&index=0&id=5320fccc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports